import { createAsyncThunk } from '@reduxjs/toolkit'

import { env } from '@/common/config/env'
import { HttpMethods } from '@/common/constants/http-methods.constants'
import api from '@/common/helpers/api.helpers'

const fetchCategories = createAsyncThunk('items/fetchCategories', async () => {
  const response = await api(HttpMethods.GET, `${env.RESIDEN_API_BASE_URL}/categories`, {})
  return response.data
})

export const categoriesService = {
  fetchCategories,
}
